import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'querystring'
import VFooter from './components/VFooter.vue'

Vue.use(ElementUI);

axios.defaults.baseURL = 'http://www.jidexianshu.com/admin'
// axios.defaults.baseURL = 'http://192.168.0.117:8088/admin'
Vue.prototype.axios = axios
Vue.prototype.qs = qs

Vue.component("v-footer",VFooter)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
